const loginIndex = () => import(/* webpackChunkName: 'loginIndex' */'../views/login/login');
const register = () => import(/* webpackChunkName: 'loginIndex' */'../views/login/register');
const aliLogin = () => import(/* webpackChunkName: 'loginIndex' */'../views/login/aliLogin');
//const yzwLogin = () => import ('../views/login/yzwlogin.vue')

export default [
    {
        path: '/login',
        name: 'login',
        component: loginIndex,
        meta: {
            title: '登录',
            requireAuth: false,
            keepAlive: false
        }
    },
    {
        path: '/register',
        name: 'register',
        component: register,
        meta: {
            title: '注册',
            requireAuth: false,
            keepAlive: false
        }
    },
    {
        path: '/ali_login',
        name: 'aliLogin',
        component: aliLogin,
        meta: {
            title: '登录',
            requireAuth: false,
            keepAlive: false
        }
    }
    // {
    //     path: 'yzwLogin',
    //     name: '登录',
    //     meta: {
    //         title: '人民法院在线服务',
    //         isWhite: true,
    //         showFooter: true,
    //         showHeader: true,
    //     },
    //     component: yzwLogin
    // }
]
